// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/scripts/" + ({"51":"pages-other-404","741":"pages-plan"}[chunkId] || chunkId) + "." + {"51":"11d0dc0d1df05b232526","108":"7eb7fab6a9e14c1557e5","741":"74c79af70303f3b4f44b"}[chunkId] + ".bundle.js";
};